import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// Self-hosted Inter (Den's brand typeface, used on the auth screens). Bundled
// same-origin (no external Google Fonts request) and declared with
// font-display: optional so the text never swaps/reflows on load. See fonts.css.
import './styles/fonts.css';
import './index.css';

// Set initial theme class to light mode by default
document.documentElement.classList.remove('dark');

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
